import React from 'react'
import { useAuth, usePage } from 'hooks'
import Breadcrumb from 'components/app/Breadcrumb'

export default function CompanyBreadcrumb() {
  const { currentCompany } = useAuth()
  const { header } = usePage()

  return (
    <Breadcrumb
      crumbs={[
        {
          label: currentCompany.name,
          value: currentCompany.id,
        },
        ...(header?.crumbs || []),
      ]}
    />
  )
}
